import React from "react";
import styled from "styled-components";

const Button = ({
  color = "primary",
  icon = "",
  name = "",
  type = "button",
  isActive = false,
  disabled = false,
  ...rest
}) => {
  const Icon = icon;

  return (
    <StyledButton
      type={type}
      color={color ?? "primary"}
      className={`btn btn-primary ${isActive ? "active" : ""}`}
      disabled={disabled}
      {...rest}
    >
      {icon && (
        <span className={name ? "me-2" : ""}>
          <Icon />
        </span>
      )}
      {name ?? ""}
    </StyledButton>
  );
};

export default Button;

const StyledButton = styled.button`
  background-color: rgb(var(--${({ color }) => color}) / 0.1) !important;
  color: rgb(var(--${({ color }) => color})) !important;
  border: 0;
  transition: background-color 0.3s ease;
  font-size: 0.8rem;
  font-weight: 600;

  &:hover,
  &:active,
  &:focus-visible {
    background-color: rgb(var(--${({ color }) => color}) / 1) !important;
    color: rgb(var(--white)) !important;
    border: 0 !important;
    box-shadow: none !important;
  }

  &.active {
    background-color: rgb(var(--${({ color }) => color}) / 1) !important;
    color: rgb(var(--white)) !important;
  }
`;
